/**
 * Offline validace bankovních spojení – port modulo-11 algoritmu ČNB
 * z legacy check_bank_account_number.php (bez zastaralého číselníku bank,
 * kód banky se kontroluje jen na formát) + IBAN mod-97. Server-side
 * pojistka běží ve Flexi režimu v bola-api (BankAccountValidator).
 */

const PREFIX_WEIGHTS = [10, 5, 8, 4, 2, 1];
const BASE_WEIGHTS = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];

function mod11(digits: string, weights: number[]): boolean {
    let sum = 0;
    for (let i = 0; i < weights.length; i++) {
        sum += Number(digits[i]) * weights[i];
    }
    return sum % 11 === 0;
}

/** Číslo účtu ČR ve formátu [prefix-]základ/kód (viz ČNB TR201). */
export function validateCzBankAccount(number: string): boolean {
    const match = /^(?:([0-9]{0,6})-)?([0-9]{2,10})\/([0-9]{4})$/.exec(number.trim());
    if (!match) {
        return false;
    }

    const [, prefix, base] = match;

    if (prefix && !mod11(prefix.padStart(6, '0'), PREFIX_WEIGHTS)) {
        return false;
    }

    return mod11(base.padStart(10, '0'), BASE_WEIGHTS);
}

/** IBAN: normalizace + délka dle země + kontrolní součet mod 97. */
export function validateIban(iban: string): boolean {
    const normalized = iban.replace(/\s+/g, '').toUpperCase();
    if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/.test(normalized)) {
        return false;
    }

    // přesun kódu země + kontrolních číslic na konec, písmena -> čísla (A=10..Z=35)
    const rearranged = normalized.slice(4) + normalized.slice(0, 4);
    let remainder = 0;
    for (const char of rearranged) {
        const value = char >= 'A' ? String(char.charCodeAt(0) - 55) : char;
        for (const digit of value) {
            remainder = (remainder * 10 + Number(digit)) % 97;
        }
    }

    return remainder === 1;
}
